import { useEffect, useState } from "react";
import Navbar from "../../Navbar/NavbarComponent/Navbar";
import SimpleButton from "../../../shared/components/Button/Button";
import ButtonLoader from "../../../shared/components/ButtonLoader";
import Loader from "../../../shared/components/Loader";
import NumberBox from "../../../shared/components/NumberBox";
import { dateConvert } from "../../../shared/helperFunc/dateConvert";
import {
  useFabricThresholdGetQuery,
  useFabricThresholdUpdateMutation,
} from "../../../Features/fabric/fabric-slice";
import {
  ACTION_LABEL,
  BUTTON_LABEL,
  LABELS,
  toastError,
  toastSuccess,
} from "../../../shared/constants";
import { fabricSettingsValidation } from "../../../shared/validation/fabric-settings-validation";
import {
  FiSliders,
  FiSave,
} from "react-icons/fi";

import authProvider from "../../../shared/config/authProvider";

const FabricSettings = (props: any) => {
  const {} = props;

  const [threshold, setThreshold]: any = useState("");
  const [lastChangedBy, setLastChangedBy] = useState("");
  const [lastChangedAt, setLastChangedAt]: any = useState(null);
  const [dataAsOf, setDataAsOf]: any = useState(null);
  const [errors, setErrors]: any = useState({});

  const {
    data: thresholdData,
    isSuccess: thresholdSuccess,
    isFetching: thresholdFetching,
    refetch: thresholdRefetch,
  } = useFabricThresholdGetQuery("", {
    refetchOnMountOrArgChange: true,
  });

  const [thresholdUpdate, { isLoading: thresholdUpdateLoading }] =
    useFabricThresholdUpdateMutation();

  useEffect(() => {
    if (thresholdSuccess && thresholdData) {
      setThreshold(String(thresholdData.item.threshold ?? ""));
      setLastChangedBy(thresholdData.item.lastChangedBy || "");
      setLastChangedAt(thresholdData.item.lastChangedAt || null);
      setDataAsOf(thresholdData.item.dataAsOf || null);
    }
  }, [thresholdData, thresholdSuccess]);

  const handleOnChange = (e: any) => {
    setThreshold(e.target.value);
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSave = async () => {
    const { formErrors, formValid } = fabricSettingsValidation({ threshold });
    if (formValid) {
      const currentUser = authProvider.getUserData()?.item;
      const currentUserName = currentUser?.name || currentUser?.username || "";
      const updatePayload: any = {
        threshold: Number(threshold),
      };
      if (currentUserName) {
        updatePayload.lastChangedBy = currentUserName;
      }
      const updateResponse = await thresholdUpdate(updatePayload)
        .unwrap()
        .catch((err: any) => {
          toastError(err.data?.errors[0]?.msg);
        });
      if (updateResponse && updateResponse?.status) {
        toastSuccess(updateResponse.message);
        if (updateResponse.item?.lastChangedBy) {
          setLastChangedBy(updateResponse.item.lastChangedBy);
        }
        if (updateResponse.item?.lastChangedAt) {
          setLastChangedAt(updateResponse.item.lastChangedAt);
        }
        thresholdRefetch();
      }
    } else {
      setErrors(formErrors);
    }
  };

  return (
    <>
      {thresholdFetching ? (
        <Loader />
      ) : (
        <div className="full-height">
          <Navbar title={LABELS.FABRIC_STOCK_SETTINGS_TEXT} />
          <main className="main-content">
            <div className="py-4">
              <div className="container-fluid">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-10 col-lg-8 col-xl-6">
                    <div className="card custom-card shadow-sm border-0 rounded-3 overflow-hidden mt-2">
                      <div
                        className="px-4 py-3 border-bottom d-flex align-items-center gap-3"
                        style={{ backgroundColor: "#FAF8F5" }}
                      >
                        <div
                          className="d-flex align-items-center justify-content-center rounded-circle"
                          style={{
                            width: "40px",
                            height: "40px",
                            backgroundColor: "#3E2215",
                            color: "#fff",
                            flexShrink: 0,
                          }}
                        >
                          <FiSliders size={18} />
                        </div>
                        <div>
                          <h5
                            className="mb-0 fw-bold"
                            style={{
                              color: "#3E2215",
                              fontFamily: "var(--heading-fonts)",
                            }}
                          >
                            {LABELS.FABRIC_STOCK_SETTINGS_TEXT}
                          </h5>
                          <small className="text-muted">
                            Configure minimum inventory threshold for low stock alerts
                          </small>
                        </div>
                      </div>

                      <div className="card-body p-4">
                        <div className="mb-3">
                          <div className="form-group value-field">
                            <NumberBox
                              name={ACTION_LABEL.THRESHOLD}
                              placeholder={LABELS.THRESHOLD_TEXT}
                              id={LABELS.THRESHOLD_TEXT}
                              label={LABELS.THRESHOLD_TEXT}
                              onChange={handleOnChange}
                              value={threshold}
                              errorMessage={errors.threshold || null}
                              min={1}
                              required
                            />
                          </div>
                        </div>

                        {(lastChangedBy || lastChangedAt) && (
                          <div className="mb-4">
                            <p className="text-muted mb-0 font-12">
                              {`${LABELS.LAST_CHANGED_BY_TEXT} ${
                                lastChangedBy || "-"
                              } ${LABELS.LAST_CHANGED_AT_TEXT} ${
                                lastChangedAt ? dateConvert(lastChangedAt) : "-"
                              }`}
                            </p>
                          </div>
                        )}

                        <div className="d-flex align-items-center justify-content-end pt-3 border-top">
                          <SimpleButton
                            className="btn theme-btn d-inline-flex align-items-center gap-2"
                            onClick={handleSave}
                            disabled={thresholdUpdateLoading}
                            text={
                              thresholdUpdateLoading ? (
                                <ButtonLoader />
                              ) : (
                                <span className="d-inline-flex align-items-center gap-2">
                                  <FiSave size={15} />
                                  <span>{BUTTON_LABEL.SAVE}</span>
                                </span>
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      )}
    </>
  );
};

export default FabricSettings;

